import { ArrowRightCircleIcon } from "@heroicons/react/24/solid";
import { ShieldExclamationIcon } from "@heroicons/react/24/solid";
import { useHistory } from "react-router";
import { selectedVIPTab } from "../modules/CarrierAgreementMgmt/VendorInvoice/InvoiceManager/atoms/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import { VendorInvoiceTabs } from "../modules/CarrierAgreementMgmt/VendorInvoice/VendorInvoiceTabs";
import { permissionsSelector } from "../modules/Login/selectors/permissionSelector";
import {
  ArrowPathRoundedSquareIcon,
  ClipboardDocumentIcon,
  ClockIcon,
  NoSymbolIcon,
  ViewfinderCircleIcon,
} from "@heroicons/react/24/outline";
const VIPCard = ({ count, duration, overCount, title, onClick }) => {
  return (
    <>
      <div className="bg-white hover:bg-secondary text-primary hover:text-white hover:h2-text-white border border-gray-200 box-shadow rounded-md relative group">
        <div className="flex w-full pl-4 pr-2 py-4 gap-x-2">
          <div className="w-full">
            <div className="flex justify-between place-content-center">
              {title === "For Review" ? (
                <ClockIcon className="text-white bg-[#0C77BD] group-hover:bg-white group-hover:text-secondary rounded-md h-7 w-7 p-1" />
              ) : title === "Reconciliation" ? (
                <ArrowPathRoundedSquareIcon className="text-white bg-[#0C77BD] group-hover:bg-white group-hover:text-secondary rounded-md h-7 w-7 p-1" />
              ) : title === "Submitted to Acumatica" ? (
                <ClipboardDocumentIcon className="text-white bg-[#0C77BD] group-hover:bg-white group-hover:text-secondary rounded-md h-7 w-7 p-1" />
              ) : title === "Voided" ? (
                <NoSymbolIcon className="text-white bg-[#0C77BD] group-hover:bg-white group-hover:text-secondary rounded-md h-7 w-7 p-1" />
              ) : (
                <ViewfinderCircleIcon className="text-white bg-[#0C77BD] group-hover:bg-white group-hover:text-secondary rounded-md h-7 w-7 p-1" />
              )}
              <div className="place-content-center cursor-pointer">
                <ArrowRightCircleIcon className="h-6 w-6" onClick={onClick} />
              </div>
            </div>
            <h2
              className="pt-2 text-sm font-bold truncate cursor-pointer"
              onClick={onClick}
            >
              {title}
            </h2>
            <h2
              className="text-xs truncate uppercase cursor-pointer"
              onClick={onClick}
            >
              INVOICES
            </h2>
            <div className="font-medium flex flex-row justify-between">
              <h1 className="-mt-5 ml-auto truncate font-bold text-4xl grid-cols-1">
                {count}
              </h1>
            </div>
            {/* <div className="flex flex-row py-2">
              <ShieldExclamationIcon className="text-yellow-500 h-4 w-4" />
              <h2 className="text-xxs truncate px-2">
                {`Over ${overCount} hours:`}
                <strong> {duration} </strong>
              </h2>
            </div> */}
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default VIPCard;
